import React from 'react';
import { BatteryLowIcon, CalendarXIcon, HourglassIcon, RepeatIcon, Volume2Icon } from 'lucide-react';
import { identification } from '../data/content';
const icons = [BatteryLowIcon, RepeatIcon, CalendarXIcon, Volume2Icon, HourglassIcon];
export function PainPoints() {
  return <section className="border-t border-ink-line bg-ink" data-id="element-141" data-mp="2bx96bdzqj8oe">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-6 lg:py-20" data-id="element-142" data-mp="2bvobdn9idnq0">
        <h2 className="mx-auto max-w-2xl text-center font-display text-[1.55rem] font-semibold leading-tight tracking-tight text-ivory sm:text-4xl" data-id="element-143" data-mp="1xwoke8yiwwqo">
          <span className="block" style={{
          fontSize: "30px"
        }} data-id="element-144" data-mp="21x085um6nd6d">{identification.titleLine1}</span>
          <span className="block text-mustard" style={{
          fontSize: "25px"
        }} data-id="element-145" data-mp="1o1wqpg82au16">{identification.titleLine2}</span>
        </h2>

        <ol className="mx-auto mt-8 grid max-w-4xl gap-2.5 md:grid-cols-2 md:gap-3" data-id="element-146" data-mp="3idupspcnq9jc">
          {identification.points.map((point, index) => {
          const Icon = icons[index];
          return <li key={point} className={`flex items-center gap-4 rounded-2xl bg-ink-raise px-4 py-3.5 sm:px-5 sm:py-4 ${index === identification.points.length - 1 ? 'md:col-span-2 md:mx-auto md:w-1/2' : ''}`} data-id="element-147" data-mp="1z056szhbqkwz" data-mpi={index}>
                <span className="w-5 flex-none font-display text-xl font-semibold text-mustard" data-id="element-148" data-mp="23qveijd82zuu">{index + 1}</span>
                <Icon className="h-5 w-5 flex-none text-sage" aria-hidden="true" data-id="element-149" data-mp="1g114sao79ret" />
                <span className="font-sans text-[0.98rem] leading-snug text-ivory/90" data-id="element-150" data-mp="1b39bpdbtjz91">{point}</span>
              </li>;
        })}
        </ol>

        <p className="mx-auto mt-10 max-w-3xl text-center font-display text-[1.75rem] font-semibold uppercase leading-[1.08] tracking-tight text-ivory sm:text-5xl" data-id="element-151" data-mp="1p3si6g0myx93">
          <span className="block" data-id="element-152" data-mp="30gmlhi2pafhj">{identification.closeLine1}</span>
          <span className="block text-terra" data-id="element-153" data-mp="2vite4lpnvffo">{identification.closeLine2}</span>
        </p>
      </div>
    </section>;
}